import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

const bookAnAppointment = (actionParams) => {
  const formStore = useFormStore()
  if (!formStore.form.values.selectedStartEndTimes) {
    return
  } else {
    apiHelperService.post('/api/appointments/add', {
      requestNumber: formStore.extraMap.requestNumbers[0],
      ...formStore.form.values
    })
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'bookAnAppointment':
      bookAnAppointment(actionParams)
      break
    default:
      break
  }
}
